import React, { useState, useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';
import EditableTable from 'app/components/EditableTable.js'
import { Alert } from 'antd'
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './ProcessScreenStyles';
import ProcessForm from 'app/components/ProcessForm';
import ProcessTableContainer from 'app/containers/ProcessTableContainer'
import { clearProcess } from 'app/actions/ProcessActions';

import { useDispatch } from 'react-redux';

export default function CompanyScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`  });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [filter, setFilter] = useState([]);
    const [idClient, setIdClient] = useState(0);
    const [visibleForm, isVisibleForm] = useState(false)
    const [nameClient, setNameClient] = useState('');
    const [isResult, setIsResult] = useState(false);
    useEffect(() => {
        return () => {
            dispatch(clearProcess())
        }
    }, []);
    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isManag={true} header='Procesos' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Gestión
                            </Link>
                        <TextEvents
                            text="Procesos"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.rootPaper}>
                    <div style={styles.baseVerticalMargin}>
                        <ProcessForm idClient={idClient} setIdClient={setIdClient} nameClient={nameClient} setNameClient={setNameClient} visibleForm={visibleForm} isVisibleForm={isVisibleForm}
                            filter={filter}
                            setFilter={setFilter}
                            pagination={pagination}
                            sorter={sorter}
                            formData={formData}
                            setFormData={setFormData}
                            classes={classes}
                            styles={styles}
                            setIsResult={setIsResult} />
                        <ProcessTableContainer
                            classes={classes}
                            sorter={sorter}
                            setSorter={setSorter}
                            
                            pagination={pagination}
                            setPagination={setPagination}
                            formData={formData}
                            isFilters={false}

                        >
                            {((param) => {
                                return (
                                    <div>
                                        {isResult ? <EditableTable
                                            formData={formData}
                                            pagination={pagination}
                                            columns={param.cols}
                                            dataSource={param.processData}
                                            loading={param.isLoading}
                                            dispatch={dispatch}
                                            onChange={param.handleTableChange}
                                        ></EditableTable>: <Alert message="En esta sección se mostrarán los resultados de 
                                        los procesos previamente consultados" type="info" showIcon />}
                                    </div>
                                )
                            })}
                        </ProcessTableContainer>
                    </div>
                </Paper>
            </div>
        </div>
    )
}